import { Block, Flex, Typography } from '@aloft/toolkit-sui';

import { selectOrderHasManufacturedProperty } from '../../redux/features/selectors/selectOrderHasManufacturedProperty.ts';
import { selectZipCodeMultipliersForOrder } from '../../redux/features/selectors/selectZipCodeMultiplier.ts';
import { useAppSelector } from '../../redux/hooks.ts';

export const ZipCodeMultiplier = () => {
  const zipCodeMultipliers = useAppSelector(selectZipCodeMultipliersForOrder);
  const hasManufactured = useAppSelector(selectOrderHasManufacturedProperty);
  return (
    <Flex flexDirection="column" gap="0.5rem">
      <Typography variant="h3">Craftsman Zip Code Multipliers</Typography>
      <Typography variant="body1">
        Craftsman uses zip code multipliers to account for locational differences in cost data
        versus a national baseline. Below you&apos;ll see the zip code multipliers used in your
        report.
        {hasManufactured
          ? ' For Manufactured Homes, Zip Code multipliers are only applied to Additional Features, including Below Grade Area.'
          : ''}
      </Typography>
      <Block marginLeft="0.5rem">
        {zipCodeMultipliers.map(({ zipCode, multiplier }) => (
          <Typography key={zipCode} variant="body1">
            &#8226; {zipCode} has a cost multiplier of {multiplier.toString()}
          </Typography>
        ))}
      </Block>
    </Flex>
  );
};
